/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import DashboardLayout from '@/views/Layout/DashboardLayout.vue';
const myProfile = () =>
  import(
    /* webpackChunkName: "my-profile" */
    '@/views/MyProfile/profile.vue'
  );
const myProfileConfig = () =>
  import(
    /* webpackChunkName: "my-profile" */
    '@/views/MyProfile/config.vue'
  );

const myProfileRoute = {
  path: '/',
  component: DashboardLayout,
  children: [
    {
      path: '/mi-perfil',
      component: myProfile,
      meta: {
        navbarType: 'light',
      },
      children: [
        {
          name: 'my-profile',
          path: '',
          component: require('@/components/Staff/profile.vue').default,
          meta: {
            navbarType: 'light',
          },
        },
        {
          name: 'current-user-permissions',
          path: 'permisos',
          component: require('@/components/Staff/permissions.vue').default,
          meta: {
            navbarType: 'light',
          },
        }
      ],
    },
    {
      path: '/configuracion',
      name: 'my-profile-config',
      component: myProfileConfig,
      meta: {
        navbarType: 'light',
      },
    }
  ],
};
export default myProfileRoute;
